
      ;(() => {
        const CONTROLLER_SCOPE_PATH = '/controller/'
        const CONTROLLER_ROUTE_PREFIX = '/controller'
        const CONTROLLER_ROLE_NAMES = new Set(['controller', 'контролёр'])
        const PWA_SCRIPT_URL_MARKERS = ['/sw.js', '/dev-sw.js']
        const PWA_CACHE_PREFIXES = ['controller-pages', 'controller-assets', 'controller-api', 'workbox-precache']
        const PWA_RECOVERY_RELOAD_KEY = 'wego-pwa-recovery-reload'

        const normalizeRole = (value) => {
          if (typeof value !== 'string') {
            return ''
          }

          return value.trim().toLowerCase()
        }

        const isControllerScope = (scope) => {
          try {
            return new URL(scope).pathname.startsWith(CONTROLLER_SCOPE_PATH)
          } catch {
            return scope.includes(CONTROLLER_SCOPE_PATH)
          }
        }

        const getStoredRole = () => {
          try {
            const rawUser = window.localStorage.getItem('authUser')
            if (!rawUser) {
              return ''
            }

            const parsedUser = JSON.parse(rawUser)
            return normalizeRole(parsedUser?.selectedRole)
          } catch {
            return ''
          }
        }

        const shouldEnableControllerPwa = () => {
          return (
            window.location.pathname.startsWith(CONTROLLER_ROUTE_PREFIX) && CONTROLLER_ROLE_NAMES.has(getStoredRole())
          )
        }

        const getRegistrationScriptUrls = (registration) => {
          return [
            registration.active?.scriptURL,
            registration.waiting?.scriptURL,
            registration.installing?.scriptURL,
          ].filter((scriptUrl) => typeof scriptUrl === 'string' && scriptUrl.length > 0)
        }

        const isAppPwaRegistration = (registration) => {
          return (
            isControllerScope(registration.scope) ||
            getRegistrationScriptUrls(registration).some((scriptUrl) =>
              PWA_SCRIPT_URL_MARKERS.some((marker) => scriptUrl.includes(marker)),
            )
          )
        }

        const cleanupStalePwa = async () => {
          if (!('serviceWorker' in navigator)) {
            return false
          }

          const shouldKeepControllerPwa = shouldEnableControllerPwa()
          const registrations = await navigator.serviceWorker.getRegistrations()
          const matchingRegistrations = registrations.filter((registration) => {
            if (!isAppPwaRegistration(registration)) {
              return false
            }

            return shouldKeepControllerPwa ? !isControllerScope(registration.scope) : true
          })

          if (!matchingRegistrations.length) {
            return false
          }

          await Promise.all(matchingRegistrations.map((registration) => registration.unregister()))

          if ('caches' in window) {
            const cacheNames = await window.caches.keys()
            await Promise.all(
              cacheNames
                .filter((cacheName) => PWA_CACHE_PREFIXES.some((prefix) => cacheName.startsWith(prefix)))
                .map((cacheName) => window.caches.delete(cacheName)),
            )
          }

          return true
        }

        const bootstrap = async () => {
          const stalePwaWasRemoved = await cleanupStalePwa()
          const alreadyReloaded = window.sessionStorage.getItem(PWA_RECOVERY_RELOAD_KEY) === '1'

          if (stalePwaWasRemoved && !alreadyReloaded) {
            window.sessionStorage.setItem(PWA_RECOVERY_RELOAD_KEY, '1')
            window.location.reload()
            return
          }

          window.sessionStorage.removeItem(PWA_RECOVERY_RELOAD_KEY)
          await import('/src/main.ts')
        }

        void bootstrap()
      })()
    